import { API } from "./api";

export const getOwnerProfileData = (id) => {
  return API.get(`/owners/${id}`);
};

export const addOwnerProfileDetails = (details) => API.post("/owners", details);
export const updateOwnerProfileDetails = (id, details) =>
  API.put(`/owners/${id}`, details);
